<!-- begin::Footer -->
<footer class="m-grid__item m-footer display-content-on-screen" appunwraptag="" style="background: #000;">
    <div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
        <div class="m-footer__wrapper">
            <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">


                <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--first">
                    <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--first">
                        <div class="row sort-footer" style="font-weight:600;">

                            <div class="copyright" style="padding: -2px 635px;
                            margin: 0 auto  ;
                            text-align: center;
                            color: #ffffff;
                            font-size: 12px;">

                                CIN L66190MH1986PLC039660<br> © {{footerYear | date: 'yyyy'}} WSFx Global Pay Ltd. All
                                Rights Reserved | <a (click)="showDisclaimer()">Disclaimer</a> |
                                <span><a href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/pdf/home/WSFx_Global_Pay_Terms_Conditions.pdf"
                                        target="_blank" rel="noopener" style="color:#FFF;">Terms & Conditions</a></span>
                                | <span><a
                                        href="https://files.wsfx.in/pdf/home/WSFX_Customer_Grievance_Redressal_Policy_v1.pdf"
                                        target="_blank" rel="noopener" style="color:#FFF;">Grievances Policy</a></span>

                            </div>
                            <ul class="m-footer__nav m-nav m-nav--inline ">
                                <li class="m-nav__item">
                                    <a href="https://www.wsfxglobalpay.com/contact-us" class="m-nav__link"
                                        target="_blank">
                                        <span class="m-nav__link-text" style="color:#ffffff">
                                            Contact Us
                                        </span>
                                    </a>
                                </li>
                                <li class="m-nav__item">
                                    <a href="https://uat.wsfxglobalpay.com/about-wsfx-global-pay-limited" rel="noopener"
                                        target="_blank" class="m-nav__link">
                                        <span class="m-nav__link-text" style="color:#ffffff">
                                            About Us
                                        </span>
                                    </a>
                                </li>

                            </ul>



                        </div>

                    </div>
                </div>






            </div>
        </div>
    </div>
</footer>
<!-- end::Footer -->


// WEBPACK FOOTER //
// ./src/app/core/layouts/footer/footer.component.html